import { render, staticRenderFns } from "./MoleculeSendRequest.vue?vue&type=template&id=1e1b9dc2&scoped=true&"
import script from "./MoleculeSendRequest.vue?vue&type=script&lang=js&"
export * from "./MoleculeSendRequest.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSendRequest.vue?vue&type=style&index=0&id=1e1b9dc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1b9dc2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default})
